import { type FC } from "react";
import { Heading } from "@root/shared/components/Heading";
import { StepChart } from "@clientFrontend/components/StepChart";
import { PreviewButtons } from "@clientFrontend/features/publication/components/PreviewButtons";
import { PrimaryActionWithNotification } from "@clientFrontend/features/publication/components/PrimaryActionWithNotification";
import { PublicationArticleContainer } from "@clientFrontend/features/publication/components/PublicationArticleContainer";
import { WorkRequirementList } from "@clientFrontend/features/publication/components/WorkRequirementList";
import type { WorkRequirement } from "@clientFrontend/features/publication/components/WorkRequirementList/type";
import * as styles from "./styles.css";

type Props = {
  step1Url: string;
  step2Url: string;
  editUrl: string;
  canEdit: boolean;
  canPreview: boolean;
  workRequirements: WorkRequirement[];
  workId: string;
  site: "biyo" | "kaigo";
};

export const WorkContentShowStep2: FC<Props> = ({
  step1Url,
  step2Url,
  editUrl,
  canEdit,
  canPreview,
  workRequirements,
  workId,
  site,
}) => {
  return (
    <PublicationArticleContainer>
      <Heading tag="h1" size="xLarge" bold className={styles.pageTitle}>
        詳細情報
      </Heading>
      <StepChart
        currentStep={2}
        step1Name="基本情報"
        step2Name="詳細情報"
        step1Url={step1Url}
        step2Url={step2Url}
        site={site}
      />
      <div className={styles.actions}>
        <PrimaryActionWithNotification
          text="編集する"
          url={editUrl}
          iconName="edit"
          canAction={canEdit}
          cannotActionType="inactive"
        >
          <p className={styles.approvingDuration}>
            ご申請から反映までの目安&nbsp;
            <span className={styles.approvingDurationExp}>最大3営業日以内</span>
          </p>
        </PrimaryActionWithNotification>
        <PreviewButtons canPreview={canPreview} workId={workId} />
      </div>
      <WorkRequirementList
        editUrl={editUrl}
        canEdit={canEdit}
        workRequirements={workRequirements}
        site={site}
      />
    </PublicationArticleContainer>
  );
};
